export default __webpack_public_path__ + "static/media/pokemonFondo1.a799982a.jpg";